import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useDeviceContext } from "src/context/device-context";
import "./styles/CheapFlights.css";

function CheapFlightsLayout() {
  const { isMobile } = useDeviceContext();
  const { key: locationKey } = useLocation();

  return (
    <main id="cheap-flights-page" className={isMobile ? "mobile" : ""}>
      <Outlet key={locationKey} />
    </main>
  );
}

export default CheapFlightsLayout;
